import { useWishList } from "@agent/context/wish-list";
import { FaRegHeart } from "react-icons/fa6";
import * as React from "react";
import { useState } from "react";
import { WishList } from "@agent/components/wish-list/WishList";
import { Modal } from "flowbite-react";

export function WhishListBadge() {
  const { wishList } = useWishList();
  const [open, setOpen] = useState(false);

  const count = wishList.length;

  const onClose = () => setOpen(false);

  return (
    <>
      <span
        className="cursor-pointer text-2xl relative px-2"
        onClick={count ? () => setOpen(true) : undefined}
      >
        <FaRegHeart />
        {count > 0 && (
          <span className="bg-red-300 text-white text-xs absolute -right-[20%] -top-2 rounded-full p-1 w-6 h-6 text-center">
            {count}
          </span>
        )}
      </span>

      <Modal
        root={document.getElementById("tuiroot")}
        show={open}
        dismissible
        size="5xl"
        onClose={onClose}
      >
        {open && <WishList onClose={onClose} />}
      </Modal>
    </>
  );
}
